import organizationLocations from './organization-locations';
import organizationPositions from './organization-positions';
import payrollBatchPayments from './payroll-batch-payments';
import payrollOrganizationContributions from './payroll-organization-contributions';
import payrolls from './payrolls';
import teamMemberAssets from './team-member-assets';
import teamMemberAttendances from './team-member-attendances';
import teamMemberBenefits from './team-member-benefits';
import teamMemberDeductionPayments from './team-member-deduction-payments';
import teamMemberDeductions from './team-member-deductions';
import teamMemberEmergencyContacts from './team-member-emergency-contacts';
import teamMemberEmploymentHistories from './team-member-employment-histories';
import teamMemberFiles from './team-member-files';
import teamMemberJurisdictionDetails from './team-member-jurisdiction-details';
import teamMemberMemos from './team-member-memos';
import teamMemberPaymentDetails from './team-member-payment-details';
import teamMemberPayrollAdjustments from './team-member-payroll-adjustments';
import teamMemberPayrollAllowances from './team-member-payroll-allowances';
import teamMemberPayslips from './team-member-payslips';
import teamMemberReportingRoles from './team-member-reporting-roles';
import teamMemberSalaryPackages from './team-member-salary-packages';
import teamMemberSettings from './team-member-settings';
import teamMemberTimeSheets from './team-member-time-sheets';
import teamMembers from './team-members';

let messages = Object.assign({}, organizationLocations, organizationPositions, payrollBatchPayments, payrollOrganizationContributions, payrolls, teamMemberAssets, teamMemberAttendances, teamMemberBenefits, teamMemberDeductionPayments, teamMemberDeductions, teamMemberEmergencyContacts, teamMemberEmploymentHistories, teamMemberFiles, teamMemberJurisdictionDetails, teamMemberMemos, teamMemberPaymentDetails, teamMemberPayrollAdjustments, teamMemberPayrollAllowances, teamMemberPayslips, teamMemberReportingRoles, teamMemberSalaryPackages, teamMemberSettings, teamMemberTimeSheets, teamMembers);

export default messages;
